import React from 'react'
import PriceListLayout from '../../components/layouts/priceListLayout'
import {
    Row,
    Col 
} from 'antd';

export default class ChangeRate extends React.Component {
    render(){
        return(
            <PriceListLayout>
                <div className="priceListInDev">
                <div className="indevelopment">
                        <Row className={"indevelopmentRow"}>
                            <Col xs={22} sm={22} md={22} lg={22} xl={22}>
                                <div className="InDevelopmentCard">
                                    <div className="inDevText">
                                        <div className="indevTop">
                                            <img src="../../clientAssets/vintage.png" alt=""/>
                                        </div>
                                        <p>این بخش از سامانه در حال توسعه ‌می‌باشد</p>
                                        <div className="indevBottom">
                                            <img src="clientAssets/vintage.png" alt=""/>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    </div>
            </PriceListLayout>
        )
    }
}